import type { ReadonlyURLSearchParams } from "next/navigation";

export interface SearchInitialState {
  search: string;
  selectedGenres: string[];
  selectedCountries: string[];
  yearType: "gregorian" | "persian";
  range: [number, number] | undefined;
}


export function parseSearchInitialState(
  searchParams: ReadonlyURLSearchParams | URLSearchParams,
): SearchInitialState {
  const search = searchParams.get("search") || "";
  const selectedGenres = searchParams.get("genres")?.split(",") || [];
  const selectedCountries = searchParams.get("countries")?.split(",") || [];

  const yearStr = searchParams.get("year");
  const range = yearStr
    ? (yearStr.split("-").map(Number) as [number, number])
    : undefined;

  const yearType: "gregorian" | "persian" =
    range && range[0] >= 1320 ? "persian" : "gregorian";

  return { search, selectedGenres, selectedCountries, yearType, range };
}
